<template>
  <div>
    <link
      href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@500;700&display=swap"
      rel="stylesheet"
    />

    <div class="wrapper">
      <div class="footer-wrapper">
        <a href="https://hodlfi.medium.com/" target="_blank"
          ><i class="fab fa-medium fa-2x"></i
        ></a>
        <a href="https://t.me/hodlfi" target="_blank"
          ><i class="fab fa-telegram fa-2x"></i
        ></a>
        <a href="https://twitter.com/hodlfi"
          ><i class="fab fa-twitter-square fa-2x"></i
        ></a>

        <a
          href="https://etherscan.io/token/0x9b574599822642b04d0ff7e5776df3a06f4540ba"
          target="_blank"
          >Contract</a
        >

        <a
          href="https://info.uniswap.org/token/0x9b574599822642b04d0ff7e5776df3a06f4540ba"
          target="_blank"
          >Uniswap</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.wrapper {
  background: black;
}
.footer-wrapper {
  color: white;
  padding: 2em;
  font-family: "Turret Road", cursive;
  display: grid;
  justify-content: space-around;
  align-items: center;
  grid-gap: 3em;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  text-align: center;
  width: 70%;
  margin: auto;

  a {
    font-family: "Turret Road", cursive;
    color: white;
    text-decoration: none;
    font-size: 1.5em;
  }
}
</style>